import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import AgentListScreen from '../component/AgentListScreen';
import Header from '../component/Header';
import SideBar from '../component/SideBar';
import Actions from '../redux/actions';
import RoutePath from '../utils/routes/RoutePath';
import PaginationComponenent from '../component/Pagination';
import Constants, { LIMIT } from '../utils/Constants';
import AppLoader from '../utils/AppLoader';
import { toast } from 'react-toastify';
import { getSavedPage, setSavedPage } from '../utils/paginationState';
import Alert from '../component/alert/alert';

const PAGINATION_KEY = 'agent-list';
const WARD_FILTER_ALL = 'all';
const WARD_FILTER_UNASSIGNED = 'unassigned';

const isRoomNurseRoleFilter = (role) => {
    const value = String(role || '').toLowerCase();
    return value === 'nurse' || value === 'room_nurse' || value === 'floor_nurse';
};

class AgentList extends Component {
    constructor(props) {
        super(props)
        this.state = {
            pageNumber: getSavedPage(PAGINATION_KEY),
            totalItem: '',
            isAgent: false,
            searchText: '',
            agentRoleFilter: '',
            wardFilterId: WARD_FILTER_ALL,
            showConfirmModal: false,
            confirmAgent: null,
            confirmIsActive: null,
        }
    }
    componentDidMount() {
        const Agent = this.props.match.path.split('/')
        if (Agent[2] === "agent" && Agent[1] === "admin") {
            this.setState({ isAgent: true })
        } else {
            this.setState({ isAgent: false })
        }
        this.getAgentList()
        this.loadActiveWards()
    }

    loadActiveWards = () => {
        const { getLoginDetails = {} } = this.props
        const isSrmIpVendor = Number(getLoginDetails?.vendorTokenDetails?.userDetails?.Vendor?.isSrmIp) === 1
        if (!isSrmIpVendor || this.state.isAgent) {
            return
        }
        this.props.getVendorWardList({}, () => { })
    }

    getAgentList = (isUpdate) => {
        const { searchText, agentRoleFilter, wardFilterId } = this.state;
        let params = {
            limit: LIMIT,
            pageNumber: this.state.pageNumber - 1,
            search: searchText,
        }
        if (agentRoleFilter) {
            params.agentRoleFilter = agentRoleFilter;
        }
        if (isRoomNurseRoleFilter(agentRoleFilter) && wardFilterId && wardFilterId !== WARD_FILTER_ALL) {
            params.srmIpWardId = wardFilterId;
        }
        this.props.agentDetailsList(params, "", (this.props.location.pathname === RoutePath.ADMIN_AGENT_LIST))
    }

    editAgent = (id) => {
        this.props.addAgentDetails(undefined)
        this.props.history.push(this.props.location.pathname === RoutePath.ADMIN_AGENT_LIST ? "/admin/agent/edit/" + id : "/vendor/agent/edit/" + id)
    }

    requestUpdateActive = (nextStatus, obj) => {
        this.setState({
            showConfirmModal: true,
            confirmAgent: obj,
            confirmIsActive: nextStatus,
        })
    }

    closeConfirmModal = () => {
        this.setState({
            showConfirmModal: false,
            confirmAgent: null,
            confirmIsActive: null,
        })
    }

    confirmUpdateActive = () => {
        const { confirmAgent, confirmIsActive } = this.state
        if (!confirmAgent) {
            this.closeConfirmModal()
            return
        }
        const callback = (response) => {
            this.closeConfirmModal()
            if (response.response_code === 0) {
                toast.success(Constants.UPDATED_SUCCESSFULLY)
                this.getAgentList(true)
            }
            else {
                toast.error(response.response_message)
            }
        }
        let params = {
            id: confirmAgent.id,
            isActive: confirmIsActive
        }

        this.props.updateAgent(params, callback, (this.props.location.pathname === RoutePath.ADMIN_AGENT_LIST))
    }

    addAgent = () => {
        this.props.addAgentDetails(undefined)
        this.props.history.push(this.props.location.pathname === RoutePath.ADMIN_AGENT_LIST ? RoutePath.ADMIN_ADD_AGENT_LIST : RoutePath.VENDOR_ADD_AGENT_LIST)
    }
    onChangePagination = (pageNumber) => {
        const { searchText, agentRoleFilter, wardFilterId } = this.state;
        let params = {
            pageNumber: (pageNumber - 1),
            limit: LIMIT,
            search: searchText,
        }
        if (agentRoleFilter) {
            params.agentRoleFilter = agentRoleFilter;
        }
        if (isRoomNurseRoleFilter(agentRoleFilter) && wardFilterId && wardFilterId !== WARD_FILTER_ALL) {
            params.srmIpWardId = wardFilterId;
        }
        const callBack = (response) => {
            this.setState({ callerList: response.response })
        }
        this.props.agentDetailsList(params, callBack, (this.props.location.pathname === RoutePath.ADMIN_AGENT_LIST))
        setSavedPage(PAGINATION_KEY, pageNumber);
        this.setState({ pageNumber: pageNumber })
    }
    handleSearchChange = (e) => {
        const value = e.target.value;
        this.setState({ searchText: value, pageNumber: 1 }, () => {
            setSavedPage(PAGINATION_KEY, 1);
            this.getAgentList();
        });
    }
    clearSearch = () => {
        this.setState({ searchText: '', pageNumber: 1 }, () => {
            setSavedPage(PAGINATION_KEY, 1);
            this.getAgentList();
        });
    }
    handleRoleFilterChange = (e) => {
        const value = e.target.value;
        this.setState({
            agentRoleFilter: value,
            wardFilterId: WARD_FILTER_ALL,
            pageNumber: 1,
        }, () => {
            setSavedPage(PAGINATION_KEY, 1);
            this.getAgentList();
        });
    }
    handleWardFilterChange = (wardId) => {
        this.setState({
            wardFilterId: wardId,
            pageNumber: 1,
        }, () => {
            setSavedPage(PAGINATION_KEY, 1);
            this.getAgentList();
        });
    }
    render() {
        const { pageNumber, isAgent, searchText, agentRoleFilter, wardFilterId, showConfirmModal, confirmIsActive, confirmAgent } = this.state;
        const { getAgentDetails = {}, getLoginDetails = {}, getVendorRoomService = {} } = this.props
        const isSrmIpVendor = Number(getLoginDetails?.vendorTokenDetails?.userDetails?.Vendor?.isSrmIp) === 1
        const { agentList = {}, vendorAgentList = {}, isLoading } = getAgentDetails
        const { agentLists = [] } = agentList
        const { agents = [], totalItems = 0, roomNurseWardCounts = {} } = vendorAgentList
        const source = isAgent ? agentLists : agents;
        const isDeactivating = confirmIsActive === 0
        const agentName = confirmAgent?.fullName || ''
        const showWardFilter = !isAgent && isSrmIpVendor && isRoomNurseRoleFilter(agentRoleFilter)
        const activeWards = (getVendorRoomService?.vendorWardListData?.wards || [])
            .filter((ward) => Number(ward?.isActive) === 1)
            .slice()
            .sort((a, b) => String(a?.wardName || '').localeCompare(String(b?.wardName || '')))
        const unassignedCount = Number(roomNurseWardCounts?.unassigned) || 0
        const allCount = Number(roomNurseWardCounts?.all) || 0

        return (
            <div className="dashboard-screen-part">
                <div className="d-flex p-0">
                    <SideBar />
                    <div className="card-right p-0">
                        <Header />
                        <div className='addButton'>
                            <div className="add-btn">
                                <button className="btn add-item" type="button" onClick={() => this.addAgent()}><i className="fa-solid fa-plus me-3"></i>{Constants.ADD_NEW_AGENT}</button>
                            </div>
                            <div className="add-btn search-box">
                                <input
                                    className="form-control search-input"
                                    placeholder="Search by name / email"
                                    value={searchText}
                                    onChange={this.handleSearchChange}
                                />
                                {searchText ? <button type="button" className="search-clear-btn" onClick={this.clearSearch}>x</button> : null}
                            </div>
                            {!isAgent && isSrmIpVendor ? (
                                <div className="add-btn search-box">
                                    <select
                                        className="form-select search-input"
                                        value={agentRoleFilter}
                                        onChange={this.handleRoleFilterChange}
                                        aria-label={Constants.AGENT_ROLE}
                                    >
                                        <option value="">{Constants.FILTER_ALL_AGENT_TYPES}</option>
                                        <option value="nurse">{Constants.FILTER_FLOOR_NURSE}</option>
                                        <option value="ward_nurse">{Constants.FILTER_WARD_NURSE}</option>
                                        <option value="head_nurse">{Constants.FILTER_HEAD_NURSE}</option>
                                        <option value="shared_portal">{Constants.FILTER_SHARED_PORTAL}</option>
                                        <option value="inpatient">{Constants.FILTER_INPATIENT_AGENT}</option>
                                        <option value="regular">{Constants.FILTER_REGULAR_AGENT}</option>
                                    </select>
                                </div>
                            ) : null}
                        </div>
                        {showWardFilter ? (
                            <div className="agent-ward-filter px-3 pb-2">
                                <div className="agent-ward-filter__label">{Constants.FILTER_BY_WARD}</div>
                                <div className="agent-ward-filter__chips">
                                    <button
                                        type="button"
                                        className={`agent-ward-chip${wardFilterId === WARD_FILTER_ALL ? ' is-active' : ''}`}
                                        onClick={() => this.handleWardFilterChange(WARD_FILTER_ALL)}
                                    >
                                        <span>{Constants.FILTER_ALL_WARDS}</span>
                                        <span className="agent-ward-chip__count">{allCount}</span>
                                    </button>
                                    {activeWards.map((ward) => {
                                        const id = String(ward?.id);
                                        const count = Number(roomNurseWardCounts?.[id]) || 0;
                                        return (
                                            <button
                                                key={`web-ward-filter-${id}`}
                                                type="button"
                                                className={`agent-ward-chip${wardFilterId === id ? ' is-active' : ''}`}
                                                onClick={() => this.handleWardFilterChange(id)}
                                            >
                                                <span>{ward?.wardName || Constants.WARD}</span>
                                                <span className="agent-ward-chip__count">{count}</span>
                                            </button>
                                        );
                                    })}
                                    {unassignedCount > 0 ? (
                                        <button
                                            type="button"
                                            className={`agent-ward-chip${wardFilterId === WARD_FILTER_UNASSIGNED ? ' is-active' : ''}`}
                                            onClick={() => this.handleWardFilterChange(WARD_FILTER_UNASSIGNED)}
                                        >
                                            <span>{Constants.FILTER_UNASSIGNED_WARD}</span>
                                            <span className="agent-ward-chip__count">{unassignedCount}</span>
                                        </button>
                                    ) : null}
                                </div>
                            </div>
                        ) : null}
                        <AgentListScreen
                            agentLists={source}
                            editAgent={(id) => this.editAgent(id)}
                            updateActive={(value, index) => this.requestUpdateActive(value, index)}
                            isAgent={isAgent}
                            isSrmIpVendor={isSrmIpVendor}
                            showWardColumn={showWardFilter}
                            currentPage={pageNumber}
                        />
                        <div className='page-content'>
                            {
                                isAgent ? (getAgentDetails?.agentList?.totalItems > (LIMIT - 1) &&
                                    <PaginationComponenent currentPage={pageNumber} countValue={isAgent ? agentList?.totalItems : totalItems} onChangeHandle={this.onChangePagination} />)
                                    :
                                    (totalItems > (LIMIT - 1) &&
                                        <PaginationComponenent currentPage={pageNumber} countValue={isAgent ? agentList?.totalItems : totalItems} onChangeHandle={this.onChangePagination} />)
                            }
                        </div>
                    </div>
                </div>
                {isLoading && <AppLoader />}
                {showConfirmModal && (
                    <Alert
                        title={isDeactivating ? Constants.DEACTIVATE_AGENT_TITLE : Constants.ACTIVATE_AGENT_TITLE}
                        description={
                            (isDeactivating ? Constants.DEACTIVATE_AGENT_MSG : Constants.ACTIVATE_AGENT_MSG) +
                            (agentName ? ` (${agentName})` : '')
                        }
                        proceed={Constants.YES}
                        cancel={Constants.NO}
                        onSuccess={() => this.confirmUpdateActive()}
                        onFailure={() => this.closeConfirmModal()}
                    />
                )}
            </div>
        );
    }
}

export const mapStateToProps = (state) => {
    return {
        getAgentDetails: Actions.getAgentDetails(state),
        getLoginDetails: Actions.getLoginDetails(state),
        getVendorRoomService: Actions.getVendorRoomService(state),
    }
};
export default withRouter(connect(mapStateToProps, {
    agentDetailsList: Actions.agentListAction,
    addAgentDetails: Actions.addAgentDetails,
    updateAgent: Actions.updateAgentAction,
    getVendorWardList: Actions.getVendorWardList,
})(AgentList));
